/**
 * Header Sticky
 * @returns Handles sticky header logic and positioning
 */
const headerSticky = () => {
  const config = {
    dom: {
      headerMenuTop: "js-header-menu-top",
      headerGroup: "js-header-group",
    },
  };

  const $headerGroup = document.querySelector(`.${config.dom.headerGroup}`);
  const { clientHeight: $headerMenuTopClientHeight } = document.querySelector(
    `.${config.dom.headerMenuTop}`
  );

  if (!$headerGroup || !$headerMenuTopClientHeight) return;

  /**
   * Set Header Group Top
   * @description Sets $headerGroup top positioning for position: sticky;
   * @description Value must be dynamic based on content from theme settings
   */
  const setHeaderGroupTop = () => {
    $headerGroup.style.top = `-${$headerMenuTopClientHeight}px`;
  };

  /**
   * Init
   */
  const init = () => {
    setHeaderGroupTop();
  };

  init();
};

headerSticky();
